// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useBreedCount = () => {
  const query = async (breedId: string | number): Promise<number | undefined> => {
    const base = (import.meta.env.ASSETS_PREFIX || location.origin) as string

    if (!base) {
      return undefined
    }

    const path = `/api/breeds/${breedId}.json`
    const url = new URL(path, base)

    try {
      const response = await fetch(url)
      const data = await response.json()

      if ('count' in data) {
        return data.count
      }
    } catch {
      return undefined
    }
  }

  return {
    query,
  }
}
